export const translation = {
    error: 'Помилка',
};
